import { useEffect, useState } from 'react';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from '@/pages/home/components/HeroSection';
import AboutSection from '@/pages/home/components/AboutSection';
import EntranceSection from '@/pages/home/components/EntranceSection';
import ReasonSection from '@/pages/home/components/ReasonSection';
import StepsSection from '@/pages/home/components/StepsSection';
import SecuritySection from '@/pages/home/components/SecuritySection';
import FaqSection from '@/pages/home/components/FaqSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div id="top" className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <HeroSection />
        <AboutSection />
        <EntranceSection />
        <ReasonSection />
        <StepsSection />
        <SecuritySection />
        <FaqSection />
        <UpdatesSection />
        <ContactSection />
      </main>
      <SiteFooter />

      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer ${
          showTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
}